import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead } from "../components/blog/BlogCategoryPage";

export const Route = createFileRoute("/blog/crm")({
  head: () => categoryHead("crm", 1),
  component: CategoryRoute,
});

function CategoryRoute() {
  return <BlogCategoryPage categoryKey="crm" page={1} />;
}
